import { ReactNode } from 'react';

import { BitcoinIcon } from '@braskai/icons';

import { Box } from '@mui/material';

import AlipayIcon from '@/shared/assets/icons/payment-methods/alipay.svg';
import ApplePayIcon from '@/shared/assets/icons/payment-methods/apple-pay.svg';
import CashPayIcon from '@/shared/assets/icons/payment-methods/cashpay.svg';
import GooglePayIcon from '@/shared/assets/icons/payment-methods/google-pay.svg';
import LinkIcon from '@/shared/assets/icons/payment-methods/link.svg';
import MastercardIcon from '@/shared/assets/icons/payment-methods/mastercard.svg';
import VisaIcon from '@/shared/assets/icons/payment-methods/visa.svg';
import WechatIcon from '@/shared/assets/icons/payment-methods/wechat.svg';

export type PaymentMethodType =
  | 'alipay'
  | 'amex'
  | 'apple_pay'
  | 'card'
  | 'cashapp'
  | 'crypto'
  | 'discover'
  | 'google_pay'
  | 'link'
  | 'mastercard'
  | 'us_bank_account'
  | 'visa'
  | 'wechat_pay';

type PaymentMethodIconProps = {
  brand?: string;
  type?: string;
};

const ICON_MAP: Record<string, string> = {
  alipay: AlipayIcon,
  apple_pay: ApplePayIcon,
  cashapp: CashPayIcon,
  google_pay: GooglePayIcon,
  link: LinkIcon,
  mastercard: MastercardIcon,
  visa: VisaIcon,
  wechat_pay: WechatIcon,
};


const COMPONENT_ICON_MAP: Record<string, ReactNode> = {
  crypto: <BitcoinIcon aria-label="Crypto" height={24} role="img" width={34} />,
};

export const PaymentMethodIcon = ({ brand, type }: PaymentMethodIconProps) => {

  const iconKey = brand?.toLowerCase() || type?.toLowerCase() || '';

  const componentIcon = COMPONENT_ICON_MAP[iconKey];
  const iconSrc = ICON_MAP[iconKey];

  if (!componentIcon && !iconSrc) {
    return null;
  }

  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'white',
        display: 'flex',
        height: 24,
        justifyContent: 'center',
        overflow: 'hidden',
        width: 34,
      }}
    >
      {componentIcon ?? <Box alt={iconKey} component="img" src={iconSrc} sx={{ objectFit: 'contain', width: 'auto' }} />}
    </Box>
  );
};
